var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtWallet1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.21,304.89l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.06h-.45v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.82.12,13.24.17h.27v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.12-3.71-.14-5.54l.28.27c-4.42,0-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.45c2.18,0,4.35,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44,319l-13.13.28-6.66.11c-2.23.05-4.46,0-6.69.06h-.45V319l0-11.19v-.5H44l13.24.06c4.41,0,8.82.12,13.24.17h.27v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.05-8.83.16-13.24.17L44,308.31l.49-.5L44.4,319l-.44-.45c2.18,0,4.35,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,319l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.06h-.44V319l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.27v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5L73.94,319l-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.27,319l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44V319l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5L415.24,319l-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.27,67.77,428.15,68l-6.66.12c-2.23,0-4.47,0-6.7,0h-.44v-.44l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.06.5-.49-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,81.88l-13.12.27-6.66.12c-2.23,0-4.46,0-6.7,0h-.44v-.44l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53L456,71c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49L430,81.88l-.45-.45c2.19,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44,67.78l-13.13.28-6.66.11c-2.23,0-4.46,0-6.69,0h-.45v-.45l0-11.19v-.5H44l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.78-.13,5.65Zm0,0-.15-5.66c0-1.86-.11-3.7-.13-5.53l.28.27c-4.42,0-8.83.16-13.24.16L44,57.09l.49-.5L44.4,67.78,44,67.33c2.18,0,4.35,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.79,142.83l13.12-.28,6.66-.11c2.23-.05,4.47,0,6.7-.05h.44v.45l.06,11.19v.5h-.5L227,154.46c-4.42,0-8.83-.11-13.24-.16h-.28V154c0-1.9.09-3.78.13-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53l-.27-.27c4.41-.05,8.82-.16,13.24-.16l13.24-.07-.5.5,0-11.19.45.45c-2.18,0-4.36,0-6.55-.06l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.56,128.72l13.12-.28,6.66-.11c2.23-.05,4.47,0,6.7-.05h.44v.45l.06,11.19v.5H255l-13.24-.06c-4.41,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.08-3.78.13-5.65Zm0,0,.14,5.66c.05,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.83-.16,13.24-.16l13.24-.07-.5.5.05-11.19.45.45c-2.18,0-4.36,0-6.55-.06l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.25,235.41c-41.59,0-41.66,59.15,0,59.15S465.91,235.41,424.25,235.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.55,270.53c-2.22,10.18-10.66,19-25.3,19-34.57,0-34.52-49.09,0-49.09h.68c-32.49.6-32.33,47.09.63,47.09C439,287.54,447,279.76,449.55,270.53Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.5,246.91a1.06,1.06,0,0,1,1.08,1v1.65a15.46,15.46,0,0,1,8,2.88c.4.29.63.54.63.95a1.12,1.12,0,0,1-1.17,1,1.14,1.14,0,0,1-.81-.29,13.41,13.41,0,0,0-6.75-2.68V263c6.84,1.32,9.72,3.67,9.72,7.7,0,4.37-4,7.45-9.63,7.62v3.21a1.08,1.08,0,0,1-2.16,0v-3.25a17.71,17.71,0,0,1-10.12-4,1,1,0,0,1-.5-.86,1.13,1.13,0,0,1,1.13-1,1.18,1.18,0,0,1,.81.29,15.07,15.07,0,0,0,8.77,3.74V264.66c-6.75-1.36-9.54-3.62-9.54-7.74s4-7.33,9.45-7.45V247.9A1.05,1.05,0,0,1,424.5,246.91Zm-1,15.65V251.32c-4.36.08-7.24,2.47-7.24,5.43C416.27,259.55,417.71,261.28,423.51,262.56Zm2,2.51v11.37c4.5-.09,7.43-2.47,7.43-5.6C432.92,268,431.34,266.27,425.49,265.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.93,81c30.28,5.43,22.29,50.28-8,44.84S177.61,75.56,207.93,81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.09,80.5c28.86,5.17,20.86,50-8.05,44.84S176.19,75.31,205.09,80.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.77,104c.15,8,4.8,15.74,15,17.56,24,4.31,30.63-32.92,6.68-37.22l-.47-.08c22.46,4.5,16,39.73-6.85,35.63C187.76,118.18,183.26,111.29,182.77,104Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,87.58a.76.76,0,0,1,.61.89l-.23,1.24a10.37,10.37,0,0,1,5.14,3.22.91.91,0,0,1,.31.8.81.81,0,0,1-1,.63.78.78,0,0,1-.52-.33,9,9,0,0,0-4.3-2.89l-1.63,8.73c4.56,1.88,6.22,4,5.65,7.08-.61,3.31-3.82,5.13-7.74,4.53l-.46,2.43a.76.76,0,1,1-1.49-.28l.46-2.46a12,12,0,0,1-6.46-4.33.85.85,0,0,1-.22-.72.84.84,0,0,1,.93-.64.85.85,0,0,1,.52.33,10.28,10.28,0,0,0,5.55,4l1.65-8.89c-4.48-1.9-6.1-4-5.51-7.09s3.77-5,7.59-4.43l.23-1.18A.76.76,0,0,1,202.76,87.58ZM199.87,99.3l1.59-8.51c-3-.5-5.37.93-5.79,3.18S196,97.58,199.87,99.3Zm1,2.16-1.6,8.6c3.13.52,5.49-.91,5.93-3.28C205.62,104.63,204.77,103.12,200.89,101.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.48,
    y: 243.66,
    width: 207.78,
    height: 100.08,
    transform: "translate(26.36 -12.32) rotate(5.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.24,253l-6.26-.55L60.55,235.3l-6.28-.56L53.72,241l-7.67,87.15-.55,6.28,6.26.55,194.45,17.12,6.25.55h0l8.79-99.7Zm-14.48,92.88L52.32,328.71,60,241.56l194.42,17.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.27,
    cy: 294.92,
    rx: 33.94,
    ry: 29.1,
    transform: "translate(-153.96 421.72) rotate(-84.97)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.21,288.48A7.8,7.8,0,1,1,98.13,280,7.8,7.8,0,0,1,105.21,288.48Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.24,298.35a7.8,7.8,0,1,1-7.09-8.45A7.8,7.8,0,0,1,217.24,298.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.19,329.93l-13.87-1.22,1.22-13.86A13.92,13.92,0,0,1,66.19,329.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,332l-1.22,13.87-13.85-1.22A13.9,13.9,0,0,1,248,332Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,257.46l13.87,1.22-1.22,13.86A13.91,13.91,0,0,1,240.56,257.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,255.42,60,241.55l13.86,1.22A13.91,13.91,0,0,1,58.77,255.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85,269.42a1.42,1.42,0,0,1,1.27,1.52l-.2,2.33a19.08,19.08,0,0,1,10,5,1.62,1.62,0,0,1,.7,1.41A1.5,1.5,0,0,1,166,281a1.47,1.47,0,0,1-1-.5,16.6,16.6,0,0,0-8.41-4.56l-1.43,16.32c8.69,2.65,12.13,6.3,11.63,12-.55,6.18-6.12,10.09-13.43,9.68l-.4,4.55a1.41,1.41,0,1,1-2.8-.24l.41-4.61a21.93,21.93,0,0,1-12.62-6.81,1.5,1.5,0,0,1-.53-1.28,1.52,1.52,0,0,1,1.58-1.33,1.5,1.5,0,0,1,1,.5,18.89,18.89,0,0,0,10.9,6.31l1.46-16.62c-8.57-2.69-11.91-6.22-11.39-12s6-9.93,13.17-9.48l.19-2.21A1.43,1.43,0,0,1,155.85,269.42Zm-3.24,22,1.4-15.92c-5.66-.38-9.69,2.68-10.06,6.87C143.6,286.38,145.25,289,152.61,291.46Zm2.25,3.78-1.41,16.09c5.84.4,9.92-2.65,10.31-7.08C164.12,300.23,162.29,297.6,154.86,295.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 139.46,
    width: 207.78,
    height: 100.08,
    transform: "translate(2.72 -4.26) rotate(0.81)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.12,140.94l-6.29-.09-195.16-2.77-6.3-.09-.09,6.29-1.23,87.48-.09,6.3,6.29.09,195.17,2.77,6.28.09h0l1.43-100.07Zm-7.61,93.69-195.17-2.78,1.24-87.48,195.17,2.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.53,
    cy: 190.72,
    rx: 33.94,
    ry: 29.1,
    transform: "translate(106.55 489.51) rotate(-89.19)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,187.84a7.8,7.8,0,1,1-7.68-7.91A7.79,7.79,0,0,1,253.13,187.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.58,189.44a7.8,7.8,0,1,1-7.69-7.91A7.8,7.8,0,0,1,365.58,189.44Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,232.05l-13.92-.2.2-13.91A13.92,13.92,0,0,1,217.26,232.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.7,220.7l-.19,13.93-13.91-.2A13.92,13.92,0,0,1,398.7,220.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.82,146.94l13.93.2-.2,13.91A13.92,13.92,0,0,1,385.82,146.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,158.29l.2-13.93,13.91.2A13.92,13.92,0,0,1,204.38,158.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.22,165.1a1.43,1.43,0,0,1,1.39,1.43l0,2.34a19.09,19.09,0,0,1,10.35,4.24,1.63,1.63,0,0,1,.8,1.36,1.5,1.5,0,0,1-1.54,1.44,1.45,1.45,0,0,1-1.05-.42,16.55,16.55,0,0,0-8.72-3.93l-.23,16.38c8.86,2,12.56,5.39,12.48,11.12-.09,6.21-5.36,10.52-12.68,10.65l-.06,4.57a1.41,1.41,0,0,1-2.81,0l.07-4.63a22,22,0,0,1-13.09-5.86,1.48,1.48,0,1,1,1.91-2.26A18.81,18.81,0,0,0,300.34,207l.24-16.68c-8.75-2.05-12.33-5.32-12.25-11.17s5.3-10.34,12.44-10.42l0-2.22A1.43,1.43,0,0,1,302.22,165.1Zm-1.6,22.22.23-16c-5.68,0-9.47,3.38-9.53,7.6C291.26,182.92,293.1,185.4,300.62,187.32Zm2.53,3.61-.23,16.15c5.85,0,9.7-3.38,9.76-7.82C312.74,195.22,310.73,192.73,303.15,190.93Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-53"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 433.09,
    rx: 208.86,
    ry: 31.66,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "40.1 380.21 92.57 379.96 145.05 379.88 250 379.71 354.95 379.88 407.43 379.96 459.9 380.21 407.43 380.45 354.95 380.54 250 380.71 145.05 380.54 92.57 380.45 40.1 380.21",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.14,196.86s12.31,113.6,12.42,117c.65,18.83.92,72.9.92,72.9l41-.11s1.07-62.36-.67-78.58C153.64,287.4,140.19,197,140.19,197Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.06,431.12c-2.2.74-65.08.72-67.48-.8-.9-.56-1.43-9.73-1.76-20.81-.08-2.39-.13-4.86-.17-7.38-.06-3-.11-6-.13-8.9-.11-13.13,0-24.7,0-24.7l40.93-.1,0,24.69,0,8.91-.2,7.38s24.07,10.78,26.52,12.72S187.25,430.39,185.06,431.12Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.06,431.12c-2.2.74-65.08.72-67.48-.8-.9-.56-1.43-9.73-1.76-20.81-.08-2.39-.13-4.86-.17-7.38-.06-3-.11-6-.13-8.9l41-.11,0,8.91-.2,7.38s24.07,10.78,26.52,12.72S187.25,430.39,185.06,431.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25,431.21c-1.43.48-28.21.64-47.71.29-4.52-.08-8.64-.2-12-.33-4.59-.2-7.67-.44-8.17-.76-1.11-.71-1.67-14.16-2-28.34l41.13-.11-.19,7.42s24.2,10.83,26.67,12.79S187.45,430.47,185.25,431.21Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.34,428.69c-10.6-.27-53.37-.33-63.86.21-.09,0-.09.07,0,.07,10.49.49,53.26.21,63.86-.11C184.56,428.85,184.56,428.69,184.34,428.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88,407c-4.17-.78-9.27-.14-12.46,2.83-.12.12,0,.29.18.25a58.1,58.1,0,0,1,12.26-2.55A.27.27,0,0,0,157.88,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.89,408.84c-4.17-.78-9.27-.14-12.46,2.83-.12.11,0,.29.18.24a58.72,58.72,0,0,1,12.26-2.54A.27.27,0,0,0,160.89,408.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.9,410.65c-4.17-.78-9.27-.14-12.46,2.83-.12.12,0,.29.18.25a58.1,58.1,0,0,1,12.26-2.55A.27.27,0,0,0,163.9,410.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,412.47c-4.17-.78-9.27-.14-12.46,2.83-.12.11,0,.29.18.24A58.72,58.72,0,0,1,166.89,413,.27.27,0,0,0,166.91,412.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,437.38c-2.27.49-64.76-6.44-67-8.21-.84-.66-.36-9.83.53-20.88.19-2.38,10-40.77,10-40.77l42.14,4.39L88,412.65s22.74,13.35,25,15.56S116.38,436.9,114.13,437.38Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.15,429.18c2.21,1.76,64.71,8.69,67,8.21s1-7-1.2-9.18-25-15.57-25-15.57l4.42-15.18-40.77-5.87c-1.78,7.16-3.88,15.8-4,16.7C46.79,419.35,46.32,428.52,47.15,429.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,437.5c-1.47.31-28.11-2.47-47.45-5-4.48-.58-8.56-1.15-11.86-1.65-4.54-.7-7.57-1.28-8-1.65-.83-.67-.46-10.08.72-20.95a42.7,42.7,0,0,1,1.67-7.44l40.5,5.36L88,412.62s22.87,13.43,25.1,15.64S116.57,437,114.3,437.5Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.68,434.88c-10.5-1.42-53-6.19-63.5-6.8-.09,0-.09.05,0,.07,10.38,1.64,52.93,6.06,63.49,6.91C113.89,435.07,113.9,434.91,113.68,434.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,410.44c-4.06-1.23-9.2-1.15-12.69,1.45-.14.1,0,.29.14.26A58.73,58.73,0,0,1,89.69,411,.27.27,0,0,0,89.76,410.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.55,412.58c-4.06-1.23-9.2-1.16-12.69,1.44-.14.1,0,.29.15.27a58.58,58.58,0,0,1,12.47-1.19A.27.27,0,0,0,92.55,412.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.34,414.71c-4.06-1.23-9.2-1.15-12.69,1.45-.14.1,0,.29.15.26a58.57,58.57,0,0,1,12.47-1.18A.27.27,0,0,0,95.34,414.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.14,416.85c-4.06-1.23-9.2-1.16-12.7,1.44-.13.1,0,.29.15.27a58.58,58.58,0,0,1,12.47-1.19A.27.27,0,0,0,98.14,416.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.82,197s-.39,14-6.76,22c-1.52,1.92-8.78,11.18-11.2,13,0,0-6.11,70.34-7.18,83-1.46,17.36-19,74.73-19,74.73l-41.1-5.85s14.15-53.27,18.1-70c.91-3.86,9-80.13,8.41-81.72-6.56-16.48,5.57-35.33,5.57-35.33Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,197s16.4,106.84,17,112.12c0,0-13.28,6.3-33.4,9.59s-58.57-10.27-58.57-10.27,13.23-72.31,13.23-72.73-4.57-19.91,7.22-38.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,248.88c-2.09,6.53-4.16,13.09-6.1,19.67s-3.88,13-5.34,19.63c-.83,3.76-1.48,7.54-2.15,11.33a.13.13,0,0,0,.25.06c.94-3.3,2-6.57,2.86-9.89s1.73-6.64,2.56-10c1.65-6.57,3.19-13.17,4.92-19.73,1-3.71,2.06-7.39,3.13-11.07C131.36,248.83,131.23,248.8,131.2,248.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4,239.55c-1.42,2.41-2.75,4.87-4,7.38-.59,1.23-1.16,2.46-1.72,3.7-.29.66-.57,1.33-.84,2a8.83,8.83,0,0,0-.67,1.84c0,.07.08.14.13.07a8.72,8.72,0,0,0,.86-1.59c.32-.64.65-1.28,1-1.93q.91-1.89,1.86-3.75c1.25-2.51,2.51-5,3.79-7.49A.23.23,0,0,0,132.4,239.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,97.65s-12.86-4.66-19.71,4.21c-7.71,10-4.14,17.9-5.48,30s-10.9,16.49-9.07,24.88,12.75,7.14,12.75,7.14,2,9.64,11.29,10.53A16,16,0,0,0,141,168.13s6.9,4.07,12.29.71c4.42-2.76,3-10.52,3-10.52s6.59,1.62,8.85-4.22c2.36-6.06-7.62-10.2-10.55-18.09-2.66-7.14-3.88-26.19-7.84-32.42S137,97.65,137,97.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34,163.34c-4,.81-8.87.62-11.86-2.56-2.77-2.95-2.34-7.47-.83-10.92,1.65-3.76,4.38-6.92,6.25-10.56a32.92,32.92,0,0,0,3.41-11.55c.51-4.84-.62-9.87.72-14.62,0-.07-.08-.09-.09,0-1.33,4.33-.52,8.9-.91,13.34a33.09,33.09,0,0,1-3.84,12.72c-2,3.74-5,7-6.52,11-1.35,3.48-1.51,7.78,1.07,10.75a9.77,9.77,0,0,0,5.22,3,17.12,17.12,0,0,0,7.43-.34C115.48,163.47,115.44,163.32,115.34,163.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.74,146.78a19,19,0,0,0-3.43-3.73,28.36,28.36,0,0,1-3.67-3.92c-4.42-5.91-6.08-13.27-7.68-20.33a85.79,85.79,0,0,0-3.72-13c0-.1-.19,0-.15,0,2.91,7.13,3.45,14.91,5.56,22.26a37.61,37.61,0,0,0,3.95,9.44,24.55,24.55,0,0,0,3,4c1.17,1.25,2.53,2.31,3.77,3.5a10.36,10.36,0,0,1,3.1,4.79,7.86,7.86,0,0,1-.9,6s0,.05.05,0A8.62,8.62,0,0,0,165.74,146.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.06,156.25c0-.09-.18,0-.13.08,1.69,3.28,2.84,7.48.37,10.68a9,9,0,0,1-9,3.19,12.59,12.59,0,0,1-5.58-2.67c-.13-.1-.31.08-.18.19,2.86,2.42,6.84,3.91,10.58,2.82a8.31,8.31,0,0,0,6.13-7.38C158.4,160.66,157.14,158.41,156.06,156.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67,147.87c6.13,19.63,17.32,41.18,24.07,43.73,7.21,2.73,35.15-1,44.85-3.45,3.17-.8-6.42-23-9.61-24.48s-25.21,4.52-27.29,4c-1.11-.28-14.51-16.3-24.06-25.77C129.1,133.44,127.67,141.45,129.67,147.87Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.2,188.69c3.29-.6,18.12-4.67,22-6.72s14.6-8.78,13.33-11.91-4.57-1.41-4.57-1.41,4.08-3.56,2.51-6.59-6.61-.19-6.61-.19,3.92-4,2.14-6.87-6.37.79-6.37.79,3.76-3.45,1.28-5.23c-3-2.15-9.18,5-13.63,6.95-1,.44-21.12,7.51-21.12,7.51Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,155.48c-4.58,5.25-7.48,6.75-14.05,8.71-.13,0-.1.24,0,.21,6.6-1.34,10.52-2.7,14.28-8.71C219.48,155.4,219.25,155.23,219,155.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.22,161.45c-5.23,5-8.37,6.68-15.1,9.24a.1.1,0,0,0,.06.18c6.8-2,10.68-3.41,15.25-9.12C223.63,161.49,223.45,161.22,223.22,161.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.61,168.77c-5.41,4.5-8.78,6.47-15.62,8.12a.13.13,0,0,0,0,.25c7.15-1,11.36-3.42,15.7-8.19C227,168.62,227,168.48,226.61,168.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,164.74s5.63-6.66,8.75-9,18-7,19.17-3.81c1.52,4.07-6.55,8.42-10.78,10,0,0,3.51,9.43-1.6,13.8S181,164.74,181,164.74Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.93,153.14c-1.3,4.72-7,6.48-11,8.35a.4.4,0,0,0-.14.64c1.21,4.05,1.74,10.12-1,13.61a.1.1,0,0,0,.15.14c3.49-3.34,3.46-9.34,1.85-13.69,4.12-1.86,9.75-3.87,10.21-9A0,0,0,0,0,208.93,153.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.1,156.24l-16.82,14.59s-8.15-16.09-9.11-26,3.8-9,9.49-4.37S154.1,156.24,154.1,156.24Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.22,151.32a.87.87,0,1,1-.87-.87A.87.87,0,0,1,138.22,151.32Zm10.29-.76a.86.86,0,1,0,1.16,1.17Zm-16.93-8.67a.87.87,0,1,0,.87.87A.87.87,0,0,0,131.58,141.89Zm5.77,25.92a.87.87,0,1,0,.87.87A.87.87,0,0,0,137.35,167.81Zm5.78-8.56a.87.87,0,1,0,.87.87A.87.87,0,0,0,143.13,159.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,154.55c.11-.1.21-.06.11,0a148.92,148.92,0,0,1-14.18,12.19s-.07,0,0-.06C138.33,164.43,149.19,155.62,150.38,154.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.41,161.18l-11.13,9.65s-8.15-16.09-9.11-26c-.27-2.81-.09-4.75.45-6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.76,181.58,140.19,197l-54.55-.2s12.3-45.59,28.56-57.68c8.14-6.05,16-4,20,2.07,1,1.54,12.07,20.69,12.21,28.7C146.57,176.93,140.76,181.58,140.76,181.58Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.12,151.32a.87.87,0,1,1-.87-.87A.87.87,0,0,1,115.12,151.32Zm10.68-.87a.87.87,0,1,0,.87.87A.87.87,0,0,0,125.8,150.45Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,137.35,150.45ZM120,141.89a.87.87,0,1,0,.87.87A.87.87,0,0,0,120,141.89Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,131.58,141.89ZM102.7,167.81a.87.87,0,1,0,.87.87A.87.87,0,0,0,102.7,167.81Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,114.25,167.81Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,125.8,167.81Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,137.35,167.81Zm-28.87-8.56a.87.87,0,1,0,.87.87A.87.87,0,0,0,108.48,159.25Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,120,159.25Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,131.58,159.25Zm11.92.09h0a.91.91,0,0,0-.37-.08.87.87,0,0,0,0,1.74.86.86,0,0,0,.81-.56C143.8,160.07,143.65,159.71,143.5,159.34ZM91.15,185.17A.87.87,0,1,0,92,186,.87.87,0,0,0,91.15,185.17Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,102.7,185.17Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,114.25,185.17Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,125.8,185.17Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,137.35,185.17Zm-40.42-8.56a.87.87,0,1,0,.87.87A.87.87,0,0,0,96.93,176.61Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,108.48,176.61Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,120,176.61Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,131.58,176.61Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,143.13,176.61Zm-56.9,18.08c-.07.27-.14.51-.21.73a.84.84,0,0,0,.23-.58A.39.39,0,0,0,86.23,194.69Zm10.7-.72a.87.87,0,1,0,.87.87A.87.87,0,0,0,96.93,194Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,108.48,194ZM120,194a.87.87,0,1,0,.87.87A.87.87,0,0,0,120,194Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,131.58,194Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.63,179.46a49.43,49.43,0,0,1,7.2-.12c1.19.09,2.37.22,3.56.39.59.08,1.17.14,1.77.2a7.71,7.71,0,0,0,1.86,0,0,0,0,1,1,0,.08,12.62,12.62,0,0,1-1.74.28,10.85,10.85,0,0,1-1.71,0c-1.21-.07-2.41-.2-3.62-.29-2.44-.18-4.88-.35-7.33-.35C123.52,179.66,123.52,179.47,123.63,179.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.19,182.61a51.75,51.75,0,0,1,5.79-1.35c1-.16,2-.27,3-.35l1.41-.1c.52,0,1,0,1.57,0,.05,0,.07.08,0,.09-.49,0-1,.17-1.46.25l-1.46.23-2.93.46c-2,.28-3.91.59-5.86,1C118.11,182.79,118.09,182.63,118.19,182.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7,138.38c.14,1,4.32,8,8.94,8.25,1.51.07,2.26-8.13,2.26-8.13l.19-.59,2.72-8.3-9.35-7.35-1.36-1s-.59,2.32-1.3,5.21c0,.14-.07.27-.1.41s-.09.32-.12.47c-.11.43-.23.87-.33,1.32s-.16.66-.23,1l-.23,1.06A56.41,56.41,0,0,0,122.7,138.38Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,126.49a17.55,17.55,0,0,0,9.29,11.42l2.72-8.3-9.35-7.35-1.36-1S125.51,123.6,124.8,126.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.12,117.31c.34,15.32-8.79,17.25-12.1,17.32-3,.06-13.21-.1-15.13-15.3s5.1-20.2,12-20.71S150.79,102,151.12,117.31Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.78,113a9.38,9.38,0,0,1-1.05-.12,1.64,1.64,0,0,1-1-.32.56.56,0,0,1-.07-.66,1.39,1.39,0,0,1,1.3-.45,2,2,0,0,1,1.31.58A.58.58,0,0,1,147.78,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.22,113.45a9.15,9.15,0,0,0,1-.22,1.71,1.71,0,0,0,1-.43.54.54,0,0,0,0-.66,1.37,1.37,0,0,0-1.33-.32,2,2,0,0,0-1.25.71A.58.58,0,0,0,137.22,113.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.59,117.36s-.08.06-.08.1c.06,1,0,2.24-1,2.61,0,0,0,.07,0,.06C139.69,119.94,139.81,118.34,139.59,117.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.63,116.3c-1.68-.09-1.73,3.28-.17,3.36S140,116.37,138.63,116.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,116.47c-.3.18-.59.51-.95.54s-.71-.32-1-.66c0,0-.06,0-.06,0,0,.64.22,1.31.91,1.41s1.09-.46,1.26-1.11C138.19,116.57,138.09,116.39,138,116.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.63,117.21s.08.05.08.09c-.06,1,0,2.25,1,2.61,0,0,0,.07,0,.06C145.54,119.78,145.41,118.19,145.63,117.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.58,116.14c1.68-.09,1.74,3.28.18,3.36S145.18,116.21,146.58,116.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,116.35c.27.17.54.49.86.51s.63-.35.86-.71c0,0,.05,0,.05,0,0,.64-.17,1.32-.79,1.45s-1-.42-1.15-1.06C147.09,116.46,147.18,116.28,147.29,116.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.48,125.85c.2.29.38.67.74.78a2.79,2.79,0,0,0,1.15,0s.06,0,0,.06A1.39,1.39,0,0,1,140,127a1.11,1.11,0,0,1-.61-1.07C139.37,125.82,139.45,125.81,139.48,125.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19,122s.21,1.56.21,2.3c0,.06-.18.1-.43.11,0,0,0,0,0,0a3.49,3.49,0,0,1-3.39-1.31c-.05-.07,0-.15.11-.1a5.29,5.29,0,0,0,3.19.92c.05-.2-.45-2.66-.33-2.67a6.5,6.5,0,0,1,1.66.39c-.34-3.26-1.21-6.44-1.5-9.69a.1.1,0,0,1,.19,0,53,53,0,0,1,2.06,10.37C146,122.65,144.48,122.1,144.19,122Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.86,124.25a4.32,4.32,0,0,1-1.69,1.36,1.9,1.9,0,0,1-1.16.1c-.85-.21-.89-1-.75-1.65a4.76,4.76,0,0,1,.36-1A5.54,5.54,0,0,0,143.86,124.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.17,125.61a1.9,1.9,0,0,1-1.16.1c-.85-.21-.89-1-.75-1.65A2,2,0,0,1,142.17,125.61Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35,120.45s-3-5-5.27-3.94-.18,8.13,2.3,9.24a2.59,2.59,0,0,0,3.55-1.16Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,118.53s0,0,0,.06c1.74.84,2.57,2.55,3.12,4.31a1.44,1.44,0,0,0-2.11-.53s0,.11,0,.1a1.58,1.58,0,0,1,1.71.67,7.27,7.27,0,0,1,.75,1.47c.07.16.37.1.32-.09a.06.06,0,0,1,0,0C125.71,122.21,124.15,118.91,121.72,118.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.55,118.88c1.66-.06,6.07-4.53,6.38-12.53,0,0-.77,7.17-1.34,8.21s2.47-2.51,2.81-9a26.22,26.22,0,0,0,6.55,3.57c3,.92,4.89.93,5.11.72s-4.23-1.73-5.41-3.15c0,0,8,3.94,11.75,4.31.44,0,1.14-8.84-4.55-12.74s-14.94,0-17.45,2.31c0,0-2.9.35-6.13,4.55S122.76,119,124.55,118.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.28,143.81c-12,15.55-23.67,42.53-22.4,50.28,1.79,11,31.65,30.26,40.39,34.49,3.28,1.59,13.2-27.05,9.72-28.79-5.54-2.77-25.17-15-25.45-17.18-.18-1.34,4.94-19.84,7.59-32C122.69,134.36,113.36,138.51,109.28,143.81Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,213.48a6.8,6.8,0,0,1-2.93,3.6,6.73,6.73,0,0,1,1.19,4.41c-.36,2.74-4.81,3.37-4.81,3.37a8.26,8.26,0,0,1,.51,4.85c-.6,2.58-5,3.86-5,3.86a7.2,7.2,0,0,1-2.23,4.55c-3.5,3.06-10.32,1-14.66-.28S128,228.9,125.74,227.65l7.89-27.92s21.09.16,26,2.38C163.74,204,172.62,209.94,171.43,213.48Z",
    style: {
      fill: "rgb(119, 68, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.47,217c-3.91-3-8.54-5.14-13-7.11a.08.08,0,0,0-.07.15c4.49,1.91,8.57,5.07,13,7.16A.12.12,0,0,0,168.47,217Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.89,224.47a12.92,12.92,0,0,0-3.06-1.42c-1.12-.43-2.24-.83-3.38-1.22-2.26-.78-4.54-1.51-6.84-2.17-.1,0-.17.12-.07.15,2.26.79,4.5,1.6,6.72,2.48,1.11.43,2.22.88,3.32,1.34a15.89,15.89,0,0,0,3.18,1.14A.17.17,0,0,0,164.89,224.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29,233.54a8.75,8.75,0,0,0-2.83-1.13l-3.11-1c-2.07-.69-4.14-1.38-6.18-2.15-.1,0-.17.12-.07.16,2.08.78,4.14,1.6,6.22,2.37l3.07,1.11a8.31,8.31,0,0,0,2.87.76A.06.06,0,0,0,160.29,233.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,168.77l-21.35-6.31s9.16-15.54,17-21.68,9.6-1.63,8.81,5.64S116,168.77,116,168.77Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.57,151.33a.87.87,0,0,1-1.68.3l.87-1.16A.86.86,0,0,1,103.57,151.33Zm10.68-.88a.87.87,0,1,0,.87.87A.87.87,0,0,0,114.25,150.45Zm-5.7-6.83a.86.86,0,0,0,.79-.79C109.08,143.09,108.81,143.35,108.55,143.62Zm12-1.52a.86.86,0,0,0-.56-.21.87.87,0,1,0,0,1.74.81.81,0,0,0,.62-.27C120.64,142.92,120.63,142.5,120.59,142.1Zm-6.34,25.71a.84.84,0,0,0-.61.26l1.46.43A.87.87,0,0,0,114.25,167.81Zm-17.32-8.56a.93.93,0,0,0-.29.05h0c-.21.31-.39.61-.57.88a.86.86,0,0,0,.86.8.87.87,0,0,0,0-1.74Zm11.55,0a.87.87,0,1,0,.87.87A.87.87,0,0,0,108.48,159.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46,164.73c.14,0,.15.14,0,.11a150.68,150.68,0,0,1-17.9-5.37s0-.08,0-.08C100.64,159.9,113.91,164.3,115.46,164.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.73,152.07c-1.07,5.63-2.37,11.52-3.58,17,0,.1-.89-.33-1.25-.47-.14-.06,0-.19.09-.15a4.3,4.3,0,0,0,.81.16c1.23-5.53,2.47-11.06,3.87-16.55C119.68,152,119.74,152,119.73,152.07Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wallet--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.7,
    y: 144.15,
    width: 214.64,
    height: 103.38,
    transform: "translate(-20.78 34.87) rotate(-6.66)",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.7,
    y: 144.15,
    width: 214.64,
    height: 103.38,
    transform: "translate(-20.78 34.87) rotate(-6.66)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.61,132l-6.45.76L182.89,156.21l-6.47.75.76,6.46,10.49,89.76.76,6.47,6.45-.76,200.28-23.41,6.45-.75h0L389.63,132Zm4.8,97L194.13,252.42l-10.48-89.76,200.26-23.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.17,
    cy: 197.1,
    rx: 30.06,
    ry: 35.06,
    transform: "translate(-20.92 34.89) rotate(-6.66)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,200.65a8.05,8.05,0,1,1-8.93-7.06A8.05,8.05,0,0,1,239.21,200.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,187.17a8.05,8.05,0,1,1-8.94-7.07A8.06,8.06,0,0,1,354.6,187.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.42,250.76l-14.29,1.66-1.67-14.27A14.38,14.38,0,0,1,208.42,250.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,214.74,394.4,229l-14.27,1.67A14.38,14.38,0,0,1,392.73,214.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63,140.93l14.28-1.67,1.67,14.27A14.37,14.37,0,0,1,369.63,140.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.31,176.94l-1.67-14.29L197.91,161A14.38,14.38,0,0,1,185.31,176.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.44,170.77a1.46,1.46,0,0,1,1.61,1.27l.28,2.4a19.68,19.68,0,0,1,11.18,2.95,1.69,1.69,0,0,1,1,1.29,1.54,1.54,0,0,1-1.38,1.68,1.48,1.48,0,0,1-1.13-.29,17.16,17.16,0,0,0-9.47-2.85l2,16.81c9.35.85,13.59,3.83,14.28,9.71.74,6.37-4.07,11.5-11.55,12.61l.54,4.69a1.45,1.45,0,0,1-2.88.33l-.55-4.74a22.66,22.66,0,0,1-14.19-4.25,1.55,1.55,0,0,1-.81-1.18,1.58,1.58,0,0,1,1.33-1.68,1.55,1.55,0,0,1,1.13.3,19.47,19.47,0,0,0,12.34,4.09l-2-17.11c-9.24-.93-13.34-3.8-14.05-9.8s4-11.31,11.34-12.34l-.26-2.29A1.46,1.46,0,0,1,286.44,170.77Zm1.34,23-1.91-16.4c-5.81.81-9.25,4.74-8.74,9.06C277.61,190.48,279.82,192.78,287.78,193.74Zm3.08,3.35,1.93,16.57c6-.82,9.49-4.76,8.95-9.32C301.26,200.2,298.86,197.92,290.86,197.09Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.51,
    y: 301.94,
    width: 79.22,
    height: 40.2,
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.91,
    cy: 322.04,
    r: 8.99,
    transform: "translate(26.5 677.54) rotate(-76.77)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.91,
    cy: 322.04,
    r: 4.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.06,
    y: 230.93,
    width: 239.78,
    height: 179.03,
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.06,
    y: 230.93,
    width: 239.78,
    height: 179.03,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.73,140.55l23.92,108.1A11.21,11.21,0,0,1,383.14,262L211.68,300a11.19,11.19,0,0,1-13.35-8.53L174.4,183.33a10.43,10.43,0,0,1,7.93-12.43l173-38.28A10.44,10.44,0,0,1,367.73,140.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.84,
    y: 183.8,
    width: 37.17,
    height: 25.69,
    rx: 4.2,
    transform: "translate(-37.45 50.76) rotate(-12.48)",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.27,167.64l-16.41,3.63a7,7,0,0,1-8.4-5.36h0a7,7,0,0,1,5.35-8.4l16.42-3.63a7,7,0,0,1,8.4,5.36h0A7.05,7.05,0,0,1,350.27,167.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.78,236.36l-1.29,1.2a.37.37,0,0,1-.17.1.39.39,0,0,1-.36-.11.36.36,0,0,1,0-.53l1.76-1.68a.39.39,0,0,1,.52,0,.43.43,0,0,1,.11.26l2.14,9.67a.37.37,0,0,1-.28.44.39.39,0,0,1-.45-.28Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,244.44l3.93-5.52a2.79,2.79,0,0,0,.46-2.22,2.78,2.78,0,0,0-3.3-2.09,2.81,2.81,0,0,0-1.69,1.1l-.4.58a.37.37,0,0,1-.62-.42l.41-.6a3.61,3.61,0,0,1,2.13-1.4,3.54,3.54,0,0,1,4.19,2.67,3.54,3.54,0,0,1-.56,2.81l-3.37,4.73,5-1.1a.38.38,0,0,1,.44.3.37.37,0,0,1-.28.44L207.5,245h-.06a.35.35,0,0,1-.3-.05A.4.4,0,0,1,207,244.44Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.24,231.85l-2.1,3.4a3.59,3.59,0,0,1,3.61,2.86,3.59,3.59,0,0,1-.49,2.76,3.68,3.68,0,0,1-2.3,1.61,3.56,3.56,0,0,1-2.74-.5.37.37,0,0,1-.12-.52.38.38,0,0,1,.53-.12,2.92,2.92,0,0,0,4-.88,2.86,2.86,0,0,0,.39-2.19,2.89,2.89,0,0,0-3.44-2.18.4.4,0,0,1-.33-.09h0a.38.38,0,0,1-.12-.54l2-3.27-4,.89a.38.38,0,0,1-.46-.29.38.38,0,0,1,.29-.46l4.92-1.09a.39.39,0,0,1,.46.3.32.32,0,0,1,0,.17A.58.58,0,0,1,220.24,231.85Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.78,237.59l-5.7,1.26h0a.31.31,0,0,1-.25,0,.35.35,0,0,1-.15-.5l4.41-8.93v0a.36.36,0,0,1,.5-.16.49.49,0,0,1,.16.16s0,0,0,.05v.05l1.6,7.22.7-.16a.38.38,0,0,1,.46.28.37.37,0,0,1-.3.44l-.7.16.4,1.81a.38.38,0,0,1-.74.16Zm-.16-.72-1.36-6.16L225.64,238Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.22,235.8a.36.36,0,0,1-.11-.52.38.38,0,0,1,.54-.12,2.91,2.91,0,0,0,2.16.37,2.9,2.9,0,0,0,2.19-3.44,2.83,2.83,0,0,0-3.42-2.19,2.86,2.86,0,0,0-1.82,1.27.37.37,0,0,1-.52.12.29.29,0,0,1-.12-.1v0s0,0,0,0a.34.34,0,0,1,0-.12.21.21,0,0,0,0-.08l-.43-4.35a.35.35,0,0,1,.09-.3.34.34,0,0,1,.22-.15l4.91-1.08a.38.38,0,1,1,.16.75l-4.58,1,.31,3.22a3.65,3.65,0,0,1,5.55,4.65,3.78,3.78,0,0,1-2.3,1.6A3.67,3.67,0,0,1,244.22,235.8Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.66,226.39a4.37,4.37,0,0,1,3.17-3.1.38.38,0,0,1,.46.27.41.41,0,0,1-.28.47,3.63,3.63,0,0,0-2.64,2.59,7,7,0,0,0-.29,2.27,3.54,3.54,0,1,1-.34,2.6,5,5,0,0,1-.18-.69A8.79,8.79,0,0,1,252.66,226.39Zm.8,4.87a.68.68,0,0,0,.08.19.22.22,0,0,1,0,.11,2.84,2.84,0,1,0-.1-.36Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.16,231.94,266,221.85,260.93,223a.37.37,0,0,1-.16-.72l5.57-1.23a.41.41,0,0,1,.22,0,.43.43,0,0,1,.25.18c0,.05.05.07.06.12a.38.38,0,0,1,0,.21l-1.93,10.58a.39.39,0,0,1-.28.3.29.29,0,0,1-.16,0A.41.41,0,0,1,264.16,231.94Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.35,219.62a2.24,2.24,0,0,1,2.17,3.67,3.49,3.49,0,1,1-2.61.58,2.29,2.29,0,0,1-1.26-1.58A2.23,2.23,0,0,1,272.35,219.62Zm2.17,9.81a2.76,2.76,0,1,0-3.29-2.1A2.74,2.74,0,0,0,274.52,229.43Zm-1.36-6.14a1.52,1.52,0,0,0,1.14-1.81,1.5,1.5,0,0,0-2.93.65A1.52,1.52,0,0,0,273.16,223.29Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.06,215.48a3.55,3.55,0,0,1,4.14,2.31s0,0,0,.06c.08.29.16.58.23.9a8.94,8.94,0,0,1-.08,4.42,4.43,4.43,0,0,1-3.18,3.1h0a.35.35,0,0,1-.45-.26.38.38,0,0,1,.27-.47,3.66,3.66,0,0,0,2.65-2.59,6.84,6.84,0,0,0,.28-2.27,3.56,3.56,0,1,1-3.89-5.2Zm3.52,2.85a2.81,2.81,0,1,0-2.15,3.35A2.81,2.81,0,0,0,294.58,218.33Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.38,219.38a6.87,6.87,0,0,1,.19-3.9,3.06,3.06,0,0,1,5.27-1.17,7.08,7.08,0,0,1,1.84,3.46,6.94,6.94,0,0,1-.22,3.9,3,3,0,0,1-5.26,1.16A6.74,6.74,0,0,1,298.38,219.38Zm.74-.16a6.17,6.17,0,0,0,1.61,3.07,2.29,2.29,0,0,0,4-.89,6.49,6.49,0,0,0-1.45-6.53,2.29,2.29,0,0,0-4,.89A6.1,6.1,0,0,0,299.12,219.22Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.61,212.5l-1.29,1.2a.37.37,0,0,1-.17.1.39.39,0,0,1-.36-.11.37.37,0,0,1,0-.53l1.76-1.68a.37.37,0,0,1,.52,0,.43.43,0,0,1,.11.26l2.14,9.67a.37.37,0,0,1-.28.44.38.38,0,0,1-.44-.28Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.87,220.58l3.93-5.53a2.76,2.76,0,0,0,.46-2.21,2.73,2.73,0,0,0-1.11-1.65,2.71,2.71,0,0,0-2.19-.44,2.77,2.77,0,0,0-1.68,1.09l-.41.58a.35.35,0,0,1-.52.1.35.35,0,0,1-.09-.51l.4-.6a3.61,3.61,0,0,1,2.13-1.4,3.54,3.54,0,0,1,4.19,2.67,3.54,3.54,0,0,1-.56,2.81l-3.37,4.73,5-1.1a.38.38,0,0,1,.44.3.37.37,0,0,1-.28.44l-5.86,1.3h-.06a.35.35,0,0,1-.3,0A.4.4,0,0,1,314.87,220.58Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.09,206l-2.1,3.4a3.67,3.67,0,0,1,2,.56,3.67,3.67,0,0,1-1.19,6.67,3.56,3.56,0,0,1-2.74-.5.37.37,0,0,1-.12-.52.38.38,0,0,1,.53-.12,2.89,2.89,0,1,0,.93-5.25.39.39,0,0,1-.33-.09h0a.4.4,0,0,1-.12-.54l2-3.28-4,.9a.39.39,0,0,1-.46-.3.38.38,0,0,1,.29-.46l4.92-1.08a.38.38,0,0,1,.46.29.32.32,0,0,1,0,.17A.58.58,0,0,1,337.09,206Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.63,211.74l-5.7,1.26h-.05a.34.34,0,0,1-.24,0,.36.36,0,0,1-.16-.5l4.42-8.93v0a.36.36,0,0,1,.5-.15.46.46,0,0,1,.16.15.33.33,0,0,0,0,.06v0l1.6,7.22.7-.16a.37.37,0,1,1,.16.73l-.7.15.39,1.81a.37.37,0,0,1-.29.44.36.36,0,0,1-.44-.28Zm-.16-.73-1.37-6.16-3.61,7.27Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.05,211.94a.38.38,0,0,1-.11-.53.4.4,0,0,1,.54-.12,2.87,2.87,0,0,0,2.16.38,2.9,2.9,0,0,0,2.19-3.44,2.83,2.83,0,0,0-3.42-2.19,2.84,2.84,0,0,0-1.81,1.27.38.38,0,0,1-.53.12.4.4,0,0,1-.12-.1v0s0,0,0,0a.34.34,0,0,1,0-.12.21.21,0,0,0,0-.08l-.43-4.35a.37.37,0,0,1,.09-.31.37.37,0,0,1,.22-.14l4.91-1.08a.38.38,0,1,1,.16.75l-4.58,1,.31,3.21a3.65,3.65,0,0,1,1.69-.87,3.54,3.54,0,0,1,2.74.48,3.5,3.5,0,0,1,1.59,2.3,3.61,3.61,0,0,1-.47,2.75,3.78,3.78,0,0,1-2.3,1.6A3.67,3.67,0,0,1,352.05,211.94Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.49,202.53a4.38,4.38,0,0,1,3.18-3.1.37.37,0,0,1,.45.26.41.41,0,0,1-.28.48,3.63,3.63,0,0,0-2.64,2.58,7.1,7.1,0,0,0-.29,2.28,3.52,3.52,0,0,1,2.34-1.77,3.56,3.56,0,1,1-2.68,4.37,5,5,0,0,1-.18-.69A8.91,8.91,0,0,1,360.49,202.53Zm.81,4.87a.54.54,0,0,0,.07.19.22.22,0,0,1,0,.11,2.84,2.84,0,1,0-.1-.36Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.59,
    y: 253.37,
    width: 94.03,
    height: 4.62,
    transform: "translate(-49.21 61.27) rotate(-12.48)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.13,
    y: 266.35,
    width: 66.57,
    height: 4.62,
    transform: "translate(-52.28 59.16) rotate(-12.48)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.78,
    y: 165.44,
    width: 46.89,
    height: 4.62,
    transform: "translate(-29.27 67.75) rotate(-12.48)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 252.97,
    width: 209.32,
    height: 61.27,
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 252.97,
    width: 209.32,
    height: 61.27,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.81,251.44l.29,110.72a11.22,11.22,0,0,1-11.17,11.24l-175.61.45a11.19,11.19,0,0,1-11.22-11.18L191.81,252a10.42,10.42,0,0,1,10.4-10.45L379.35,241A10.43,10.43,0,0,1,389.81,251.44Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.52,346.63a10.31,10.31,0,1,1-10.34-10.28A10.31,10.31,0,0,1,361.52,346.63Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.21,346.59a10.31,10.31,0,1,1-10.34-10.28A10.32,10.32,0,0,1,374.21,346.59Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.5,
    y: 260.45,
    width: 37.17,
    height: 25.69,
    rx: 4.2,
    transform: "translate(-0.71 0.59) rotate(-0.15)",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,274.17l-16.82.05a7,7,0,0,1-7.06-7h0a7,7,0,0,1,7-7.06l16.82-.05a7,7,0,0,1,7.06,7h0A7,7,0,0,1,367,274.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.23,309.6l-1.52.9a.39.39,0,0,1-.18.06.37.37,0,0,1-.33-.18.36.36,0,0,1,.14-.51l2.08-1.27a.38.38,0,0,1,.5.14.39.39,0,0,1,.05.28l0,9.9a.37.37,0,0,1-.37.37.38.38,0,0,1-.37-.37Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.64,318.62l5-4.56a2.77,2.77,0,0,0-3.74-4.1l-.52.48a.36.36,0,0,1-.53,0,.35.35,0,0,1,0-.52l.52-.49a3.58,3.58,0,0,1,2.38-.92,3.44,3.44,0,0,1,2.59,1.15,3.4,3.4,0,0,1,.93,2.36,3.54,3.54,0,0,1-1.14,2.62l-4.31,3.9H217a.38.38,0,0,1,.37.39.38.38,0,0,1-.37.37h-6.06a.34.34,0,0,1-.28-.11A.4.4,0,0,1,210.64,318.62Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.23,309.14,223.45,312a3.61,3.61,0,0,1,2.92,3.57,3.62,3.62,0,0,1-1.07,2.59,3.67,3.67,0,0,1-2.59,1.08,3.6,3.6,0,0,1-2.57-1.07.36.36,0,0,1,0-.54.38.38,0,0,1,.54,0,2.9,2.9,0,0,0,2,.83,3,3,0,0,0,2-.84,2.87,2.87,0,0,0,.84-2.05,2.89,2.89,0,0,0-2.89-2.87.43.43,0,0,1-.31-.16h0a.38.38,0,0,1,0-.55l2.67-2.77h-4.13a.39.39,0,0,1,0-.77h5a.38.38,0,0,1,.38.38.29.29,0,0,1,0,.17A.41.41,0,0,1,226.23,309.14Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.3,317l-5.84,0h0a.32.32,0,0,1-.23-.08.35.35,0,0,1-.05-.52l6.22-7.78v0a.36.36,0,0,1,.52-.05.46.46,0,0,1,.13.19s0,0,0,.06v.05l0,7.39h.73a.37.37,0,1,1,0,.74h-.73v1.85a.38.38,0,0,1-.75,0Zm0-.74,0-6.31-5.08,6.32Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.81,318.12a.38.38,0,0,1,0-.54.4.4,0,0,1,.56,0,2.9,2.9,0,0,0,2,.83,2.85,2.85,0,0,0,2-.86,2.79,2.79,0,0,0,.84-2,2.9,2.9,0,0,0-.83-2,2.91,2.91,0,0,0-4.08,0,.38.38,0,0,1-.54,0,.28.28,0,0,1-.1-.12v0a.06.06,0,0,1,0,0,.27.27,0,0,1,0-.13.31.31,0,0,0,0-.07l.51-4.35a.33.33,0,0,1,.15-.28.38.38,0,0,1,.25-.09h5a.39.39,0,1,1,0,.77H250l-.38,3.2a3.63,3.63,0,0,1,1.83-.49,3.6,3.6,0,0,1,3.64,3.64,3.59,3.59,0,0,1-1,2.59,3.81,3.81,0,0,1-2.59,1.07A3.65,3.65,0,0,1,248.81,318.12Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.06,310.73a4.39,4.39,0,0,1,3.77-2.35.38.38,0,0,1,.39.35.41.41,0,0,1-.37.41,3.63,3.63,0,0,0-3.14,2,6.93,6.93,0,0,0-.76,2.16,3.54,3.54,0,1,1-.89,2.46,5.39,5.39,0,0,1,0-.7A8.94,8.94,0,0,1,259.06,310.73Zm-.25,4.93a1.06,1.06,0,0,0,0,.2.34.34,0,0,1,0,.11,2.84,2.84,0,1,0,0-.37Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.12,318.61l4-9.47h-5.2a.38.38,0,0,1-.37-.37.37.37,0,0,1,.36-.37h5.7a.36.36,0,0,1,.23,0,.43.43,0,0,1,.21.23.61.61,0,0,1,0,.13.36.36,0,0,1-.06.2l-4.15,9.93a.38.38,0,0,1-.34.23.27.27,0,0,1-.15,0A.41.41,0,0,1,269.12,318.61Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.74,308.32a2.25,2.25,0,0,1,2.26,2.23,2.29,2.29,0,0,1-.92,1.82,3.49,3.49,0,1,1-2.66,0,2.28,2.28,0,0,1-.9-1.82A2.22,2.22,0,0,1,279.74,308.32Zm0,10a2.76,2.76,0,1,0-2.76-2.75A2.74,2.74,0,0,0,279.77,318.36Zm0-6.28a1.54,1.54,0,0,0,1.51-1.53,1.5,1.5,0,1,0-1.51,1.53Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.91,308.27a3.55,3.55,0,0,1,3.55,3.13.19.19,0,0,0,0,.08q0,.43,0,.93a8.88,8.88,0,0,1-1,4.3,4.46,4.46,0,0,1-3.77,2.35h0a.37.37,0,0,1-.39-.36.4.4,0,0,1,.37-.4,3.65,3.65,0,0,0,3.14-2,6.61,6.61,0,0,0,.76-2.16,3.51,3.51,0,0,1-2.67,1.19,3.55,3.55,0,1,1,0-7.1Zm2.83,3.54a2.82,2.82,0,1,0-2.82,2.81A2.8,2.8,0,0,0,301.74,311.81Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.23,313.65a6.9,6.9,0,0,1,1-3.78,3.06,3.06,0,0,1,5.39,0,7.28,7.28,0,0,1,0,7.53,3,3,0,0,1-5.39,0A6.78,6.78,0,0,1,305.23,313.65Zm.76,0a6.13,6.13,0,0,0,.91,3.34,2.29,2.29,0,0,0,4.13,0,6.46,6.46,0,0,0,0-6.68,2.29,2.29,0,0,0-4.12,0A6,6,0,0,0,306,313.64Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.67,309.32l-1.52.89a.4.4,0,0,1-.18.07.38.38,0,0,1-.33-.19.35.35,0,0,1,.14-.51l2.07-1.27a.39.39,0,0,1,.51.14.4.4,0,0,1,.05.28l0,9.9a.37.37,0,0,1-.74,0Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.08,318.33l5-4.55a2.77,2.77,0,0,0-1.86-4.82,2.84,2.84,0,0,0-1.88.71l-.52.48a.36.36,0,0,1-.53,0,.35.35,0,0,1,0-.52l.52-.5a3.6,3.6,0,0,1,2.38-.91,3.53,3.53,0,0,1,3.52,3.5,3.54,3.54,0,0,1-1.14,2.62l-4.31,3.91,5.1,0a.38.38,0,0,1,.37.39.38.38,0,0,1-.37.37h-6.06a.34.34,0,0,1-.28-.11A.41.41,0,0,1,321.08,318.33Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,308.83l-2.78,2.87a3.59,3.59,0,0,1,2.92,3.57,3.59,3.59,0,0,1-1.07,2.59,3.63,3.63,0,0,1-5.16,0,.38.38,0,0,1,0-.54.37.37,0,0,1,.54,0,2.87,2.87,0,0,0,2,.82,2.94,2.94,0,0,0,2-.83,2.9,2.9,0,0,0-2-4.93.36.36,0,0,1-.31-.15h0a.39.39,0,0,1,0-.55l2.67-2.77h-4.12a.38.38,0,0,1-.39-.38.38.38,0,0,1,.38-.39h5a.38.38,0,0,1,.39.38.29.29,0,0,1,0,.17A.22.22,0,0,1,345.9,308.83Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,316.69h-5.88a.28.28,0,0,1-.23-.07.35.35,0,0,1-.05-.52l6.22-7.78,0,0a.35.35,0,0,1,.52-.05.55.55,0,0,1,.12.19s0,0,0,.06v.05l0,7.39h.72a.37.37,0,1,1,0,.74h-.72v1.85a.37.37,0,0,1-.38.37.38.38,0,0,1-.37-.37Zm0-.74v-6.31L349.87,316Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.25,317.83a.38.38,0,0,1,0-.54.4.4,0,0,1,.56,0,2.87,2.87,0,0,0,4.06,0,2.81,2.81,0,0,0,.84-2,2.83,2.83,0,0,0-2.87-2.87,2.83,2.83,0,0,0-2,.85.36.36,0,0,1-.54,0,.23.23,0,0,1-.1-.12h0a.11.11,0,0,1,0-.05.23.23,0,0,1,0-.12s0-.05,0-.08l.51-4.35a.32.32,0,0,1,.15-.27.33.33,0,0,1,.25-.1h5a.39.39,0,1,1,0,.77h-4.69l-.38,3.21a3.63,3.63,0,0,1,5.47,3.14,3.59,3.59,0,0,1-1.05,2.59,3.72,3.72,0,0,1-2.59,1.07A3.65,3.65,0,0,1,359.25,317.83Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.5,310.45a4.38,4.38,0,0,1,3.77-2.36.38.38,0,0,1,.38.36.39.39,0,0,1-.36.4,3.65,3.65,0,0,0-3.14,2,7.2,7.2,0,0,0-.77,2.16,3.55,3.55,0,1,1-.88,2.47,5.47,5.47,0,0,1,0-.71A8.93,8.93,0,0,1,369.5,310.45Zm-.25,4.92a1.06,1.06,0,0,0,0,.2.34.34,0,0,1,0,.11,2.84,2.84,0,1,0,0-.37Z",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.68,
    y: 337.66,
    width: 94.03,
    height: 4.62,
    transform: "translate(-0.88 0.66) rotate(-0.15)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 347.96,
    width: 66.57,
    height: 4.62,
    transform: "translate(-0.91 0.63) rotate(-0.15)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.72,
    y: 260.22,
    width: 46.89,
    height: 4.62,
    transform: "translate(-0.68 0.81) rotate(-0.15)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 272.61,
    width: 209.32,
    height: 102.59,
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 272.61,
    width: 209.32,
    height: 102.59,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 290.84,
    width: 209.32,
    height: 102.59,
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 290.84,
    width: 209.32,
    height: 102.59,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 309.64,
    width: 209.32,
    height: 83.8,
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 309.64,
    width: 209.32,
    height: 83.8,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.15,441,171.06,410v-179l7,5.18a23.37,23.37,0,0,0,11.49,4.49L389.15,262Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.35,
    y: 238.63,
    width: 1,
    height: 2,
    transform: "translate(-122.78 227.38) rotate(-51.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,270l-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.46Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7-.79-4-.45.11-1,4,.45Zm-7.06-.78-4-.46.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.05-.79-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.12-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.06-.78-4-.46.11-1,4,.45ZM276.2,259l-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.46Zm-7.06-.79-4-.45.11-1,4,.45ZM248,255.8l-4-.45.11-1,4,.45Zm-7.05-.79-4-.45.12-1,4,.45Zm-7.06-.78-4-.46.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7-.79-4-.45.11-1,4,.46Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.06-.79-4-.45.11-1,4,.45Zm-7.06-.79-2.4-.26c-.56-.07-1.11-.15-1.66-.25l.18-1c.53.09,1.06.17,1.59.23l2.4.27Zm-7.07-1.26a25.07,25.07,0,0,1-3.82-1.6l.47-.89a23,23,0,0,0,3.66,1.53ZM178,245c-.33-.24-.66-.48-1-.73l-2.25-1.76.61-.79,2.25,1.76c.31.24.63.47.95.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.58 272.06 379.58 272.06 379.58 270.51 378.03 270.33 378.14 269.34 380.58 269.61 380.58 272.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.58,427.89h-1v-4.05h1Zm0-7.09h-1v-4.05h1Zm0-7.08h-1v-4.05h1Zm0-7.08h-1v-4.05h1Zm0-7.09h-1v-4h1Zm0-7.08h-1v-4.05h1Zm0-7.08h-1v-4.05h1Zm0-7.09h-1v-4h1Zm0-7.08h-1v-4.05h1Zm0-7.08h-1v-4.05h1Zm0-7.08h-1V353h1Zm0-7.09h-1v-4h1Zm0-7.08h-1v-4.05h1Zm0-7.08h-1v-4.05h1Zm0-7.09h-1v-4h1Zm0-7.08h-1v-4.05h1Zm0-7.08h-1v-4.05h1Zm0-7.09h-1v-4h1Zm0-7.08h-1v-4.05h1Zm0-7.08h-1v-4.05h1Zm0-7.08h-1v-4.05h1Zm0-7.09h-1v-4h1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.58 433.5 378.02 433.12 378.17 432.13 379.58 432.34 379.58 430.92 380.58 430.92 380.58 433.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,432.68l-4-.59.14-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.14-1,4,.59Zm-7-1-4-.59.14-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.6Zm-7-1-4-.59.14-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.6Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.14-1,4,.6Zm-7-1-4-.59.14-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.6Zm-7-1-4-.59.14-1,4,.59Zm-7-1-4-.59.15-1,4,.6Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.6Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.14-1,4,.6Zm-7-1-4-.59.15-1,4,.59Zm-7-1-4-.59.15-1,4,.6Zm-7-1-4-.59.15-1,4,.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.55,
    y: 401.02,
    width: 1,
    height: 2,
    transform: "translate(-250.89 513.11) rotate(-81.55)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 361.03,
    cy: 350.43,
    rx: 8.69,
    ry: 9.9,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.08,350.43a4.08,4.08,0,1,1-4.05-4.6A4.35,4.35,0,0,1,365.08,350.43Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.17,392.76c41.46,7.44,30.51,68.85-11,61.4S299.65,385.31,341.17,392.76Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.17,392.76c41.46,7.44,30.51,68.85-11,61.4S299.65,385.31,341.17,392.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,392.06c39.51,7.09,28.55,68.5-11,61.4S297.7,385,337.28,392.06Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,392.06c39.51,7.09,28.55,68.5-11,61.4S297.7,385,337.28,392.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.71,424.21c.21,10.94,6.58,21.54,20.49,24,32.84,5.9,41.93-45.08,9.14-51-.21,0-.42-.08-.64-.1,30.75,6.15,21.93,54.39-9.38,48.77C313.55,443.66,307.39,434.22,306.71,424.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.18,403.65a1.05,1.05,0,0,1,.76,1.26l-.42,1.69a14.23,14.23,0,0,1,6.77,4.82,1.2,1.2,0,0,1,.34,1.12,1.1,1.1,0,0,1-1.35.77,1,1,0,0,1-.69-.48,12.34,12.34,0,0,0-5.64-4.31L332,420.31c6.07,2.95,8.17,6,7.14,10.15-1.12,4.47-5.66,6.69-11,5.55l-.82,3.28a1,1,0,0,1-2-.5l.83-3.33a16.34,16.34,0,0,1-8.46-6.45,1.1,1.1,0,1,1,1.76-1.31,14.05,14.05,0,0,0,7.26,5.89l3-12c-6-3-8-5.94-7-10.15s5.58-6.58,10.75-5.42l.4-1.6A1,1,0,0,1,335.18,403.65Zm-4.92,15.78,2.87-11.5c-4.11-.94-7.41.83-8.17,3.87C324.25,414.66,325.15,416.77,330.26,419.43Zm1.21,3-2.9,11.63c4.24,1,7.59-.79,8.39-4C337.68,427.19,336.65,425.05,331.47,422.46Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M240.45,54.78c-41.59,0-41.66,59.15,0,59.15S282.11,54.78,240.45,54.78Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.45,54.78c-41.59,0-41.66,59.15,0,59.15S282.11,54.78,240.45,54.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.74,89.9c-2.22,10.17-10.65,19-25.3,19-34.57,0-34.51-49.09,0-49.09h.68c-32.48.6-32.32,47.09.64,47.09C255.21,106.91,263.22,99.13,265.74,89.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.7,66.28a1.06,1.06,0,0,1,1.08,1v1.65a15.38,15.38,0,0,1,8,2.88c.4.29.63.53.63,1a1.12,1.12,0,0,1-1.17,1,1.19,1.19,0,0,1-.81-.29,13.48,13.48,0,0,0-6.75-2.68V82.34c6.84,1.32,9.72,3.66,9.72,7.7,0,4.36-4,7.45-9.63,7.62v3.21a1.08,1.08,0,0,1-2.16,0V97.61a17.66,17.66,0,0,1-10.13-4,1.05,1.05,0,0,1-.49-.86,1.12,1.12,0,0,1,1.12-1,1.14,1.14,0,0,1,.81.29,15.17,15.17,0,0,0,8.78,3.74V84c-6.75-1.36-9.54-3.63-9.54-7.74s4-7.33,9.45-7.45V67.27A1.05,1.05,0,0,1,240.7,66.28Zm-1,15.65V70.69c-4.37.08-7.25,2.47-7.25,5.43C232.46,78.92,233.9,80.65,239.71,81.93Zm2,2.51V95.8c4.5-.08,7.42-2.47,7.42-5.6C249.11,87.36,247.54,85.63,241.69,84.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M85.55,158.25c30.28,5.44,22.28,50.29-8,44.85S55.22,152.81,85.55,158.25Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.55,158.25c30.28,5.44,22.28,50.29-8,44.85S55.22,152.81,85.55,158.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71,157.74c28.85,5.18,20.85,50-8,44.85S53.8,152.56,82.71,157.74Z",
    style: {
      fill: "#186D79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71,157.74c28.85,5.18,20.85,50-8,44.85S53.8,152.56,82.71,157.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.38,181.22c.16,8,4.81,15.74,15,17.56,24,4.3,30.62-32.93,6.68-37.22l-.47-.08c22.45,4.5,16,39.73-6.85,35.62C65.38,195.43,60.88,188.53,60.38,181.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.38,164.83a.77.77,0,0,1,.61.88L80.76,167a10.37,10.37,0,0,1,5.14,3.22.87.87,0,0,1,.3.8.8.8,0,0,1-1,.62.73.73,0,0,1-.52-.32,9.16,9.16,0,0,0-4.3-2.9l-1.63,8.73c4.55,1.89,6.22,4,5.65,7.09-.62,3.31-3.83,5.13-7.75,4.53l-.45,2.43a.76.76,0,1,1-1.5-.28l.46-2.46a12,12,0,0,1-6.45-4.34.79.79,0,0,1-.22-.71.83.83,0,0,1,.92-.64.78.78,0,0,1,.52.32,10.26,10.26,0,0,0,5.55,4l1.66-8.88c-4.49-1.9-6.1-4-5.52-7.1s3.78-5,7.6-4.42l.22-1.18A.77.77,0,0,1,80.38,164.83Zm-2.89,11.72L79.07,168c-3-.51-5.37.93-5.79,3.18S73.64,174.83,77.49,176.55Zm1,2.16-1.6,8.6c3.13.52,5.49-.91,5.94-3.28C83.24,181.88,82.39,180.36,78.5,178.71Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtWallet1);
export default __webpack_public_path__ + "static/media/art__wallet__1.31b1ff2f7691a97bc251e58869d717d6.svg";
export { ForwardRef as ReactComponent };